// Реестры заказчику и документы рейса: /api/v2/registry/* (erp-backend, модуль src/registry).
import { useAxiosCreate } from '@/backend/utils.js'
import { downloadBlobResponse } from '@/backend/download.js'

const api = useAxiosCreate('api')
const clean = (params) => Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== '' && v !== null && v !== undefined))

export const registryApi = {
  settings: () => api.get('registry/settings').then((r) => r.data),
  saveSettings: (patch) => api.put('registry/settings', patch).then((r) => r.data),
  customers: () => api.get('registry/customers').then((r) => r.data),
  terms: (customerId) => api.get('registry/terms', { params: { customer_id: customerId } }).then((r) => r.data),
  addTerms: (payload) => api.post('registry/terms', payload).then((r) => r.data),
  calendar: (customerId) => api.get('registry/calendar', { params: { customer_id: customerId } }).then((r) => r.data),
  addPaymentDay: (payload) => api.post('registry/calendar', payload).then((r) => r.data),
  deletePaymentDay: (id) => api.delete(`registry/calendar/${id}`).then((r) => r.data),
  importCalendar(customerId, file) {
    const form = new FormData()
    form.append('file', file)
    return api.post('registry/calendar/import', form, { params: { customer_id: customerId } }).then((r) => r.data)
  },
  registries: (customerId, dateFrom, dateTo) =>
    api.get('registry/registries', { params: clean({ customer_id: customerId, date_from: dateFrom, date_to: dateTo }) }).then((r) => r.data),
  createRegistry: (payload) => api.post('registry/registries', payload).then((r) => r.data),
  plan: (payload) => api.post('registry/registries/plan', payload).then((r) => r.data),
  updateRegistry: (id, patch) => api.patch(`registry/registries/${id}`, patch).then((r) => r.data),
  deleteRegistry: (id) => api.delete(`registry/registries/${id}`).then((r) => r.data),
  candidates: (id, filters) => api.get(`registry/registries/${id}/candidates`, { params: clean(filters) }).then((r) => r.data),
  addTrips: (id, tripIds) => api.post(`registry/registries/${id}/trips`, { trip_ids: tripIds }).then((r) => r.data),
  removeTrips: (id, tripIds) => api.post(`registry/registries/${id}/trips/remove`, { trip_ids: tripIds }).then((r) => r.data),
  alerts: (customerId) => api.get('registry/alerts', { params: clean({ customer_id: customerId }) }).then((r) => r.data),
  documents: (tripId) => api.get(`registry/trips/${tripId}/documents`).then((r) => r.data),
  addDocument: (tripId, payload) => api.post(`registry/trips/${tripId}/documents`, payload).then((r) => r.data),
  updateDocument: (tripId, docId, payload) => api.patch(`registry/trips/${tripId}/documents/${docId}`, payload).then((r) => r.data),
  deleteDocument: (tripId, docId) => api.delete(`registry/trips/${tripId}/documents/${docId}`).then((r) => r.data),
  setPackage: (tripIds, complete, comment) => api.post('registry/trips/package', { trip_ids: tripIds, complete, comment }).then((r) => r.data),
  async print(id, fallback) {
    const response = await api.get(`registry/registries/${id}/print`, { responseType: 'blob', validateStatus: () => true })
    return downloadBlobResponse(response, fallback || `Реестр ${id}.xlsx`)
  },
}

export function errorText(error) {
  const detail = error?.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join('; ')
  return error?.message || 'Не удалось выполнить запрос'
}
